var React = require('react');

function Upload (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 8L2 16L16 16L16 8V6.00001C17 6.00001 18 7.00001 18 8V16C18 17.1 17.1 18 16 18H2C0.899999 18 0 17.1 0 16V8C0 7.00001 1 6.00001 2 6.00001L2 8ZM4 5.00001L5.4 6.40001L8 3.80001V14H10V3.80001L12.6 6.40001L14 5.00001L9 7.62939e-06L4 5.00001Z","fill":"black"}));
}

Upload.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Upload;

Upload.default = Upload;
